/*eslint no-console: 0*/
const  EventBus = window.VueEventBus
import config from '../../lib/config'
import PageMixins from '../../components/_mixins/pages'
import { getFirstErrorMessage } from '~/lib/axios'

export default {
  name: 'raceway-password-reset',
  settings: 'page.reset-password',
  translations: 'page.reset-password',
  props: [
    'email',
    'token',
    'submitLabel',
    'header',
    'submitClass',
    'emailLabel',
    'passwordLabel',
    'passwordConfirmationLabel',
    'noPlaceholders',
    'emailPlaceholder',
    'passwordPlaceholder',
    'passwordConfirmationPlaceholder',
    'noSuccessModal',
    'successMessage'
  ],
  mixins: [PageMixins],
  data() {
    return {
      isSubmitting: false,
      success: false,
      error: null,
    }
  },
  mounted() {

  },
  created() {
    // window.skipGlobalTimerMessage = true
    this.query = this.$route.query
    EventBus.$on('password-reset.success', (email, status) => {
      this.success = true
    })
    EventBus.$on('password-reset.failed', (e, email) => {
        // this.error = getFirstErrorMessage(e)
      this.alert(getFirstErrorMessage(e))
    })
    EventBus.$on('password-reset.init', () => {
      this.success = false
      this.error = null
      this.isSubmitting = true
    })
    EventBus.$on('password-reset.end', () => {
      this.isSubmitting = false
    })
  },
  computed: {

  },
  methods: {

  }
}
